<!-- 完善基本信息 -->
<style lang="scss" scoped>
.basic-info-wrapper {
  background: #ffffff;
  padding: 20px;
}
.footer {
  text-align: end;
  margin-top: 20px;
}

.checkbox-box {
  display: flex;
  align-items: center;
  margin-left: 30px;

  ::v-deep {
    .el-checkbox__label {
      padding-left: 4px;
      padding-top: 2px;
    }
  }
}
</style>

<template>
  <div class="basic-info-wrapper mt-24px">
    <el-form ref="formRef" :model="form" :rules="rules" size="large" label-position="top" label-width="90px">
      <div class="g-title">合伙人类型</div>
      <el-row>
        <el-col :span="12">
          <el-form-item label="合伙人类型" prop="companyType">
            <el-radio-group v-model="form.companyType">
              <el-radio :label="1">企业</el-radio>
              <el-radio :label="2">个人</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <!-- 城市合伙显示合作城市 -->
        <template v-if="joinType === JOIN_TYPE_ENUM.CITY_PARTNER.value">
          <el-col :span="12">
            <el-form-item label="合作城市" prop="cooperationCityCodes">
              <el-cascader
                ref="cascaderCity"
                v-model="form.cooperationCityCodes"
                style="width: 100%"
                :options="cityData"
                placeholder="请选择合作城市"
                separator=""
                filterable
                @change="handleRegionChange"
              />
            </el-form-item>
          </el-col>
        </template>
      </el-row>

      <template v-if="form.companyType === 1">
        <div class="g-title">企业基础信息</div>
        <CompanyItem
          ref="companyItemRef"
          :joinForm="form"
          @setFormData="
            (data) => {
              updateFormData('legal', data)
            }
          "
        />

        <div class="g-title">法定代表人信息</div>
        <LegalItem
          ref="legalItemRef"
          :joinForm="form"
          @setFormData="
            (data) => {
              updateFormData('', data)
            }
          "
        />

        <div class="g-title">
          被授权人（经办人）信息
          <div class="checkbox-box">
            <!-- <span class="label">被授权人</span> -->
            <el-checkbox v-model="form.equalLegal" :true-value="1" :false-value="0" label="同法人" @change="changeEqualLegal" />
          </div>
        </div>
        <AgentItem
          ref="agentItemRef"
          :joinForm="form"
          @setFormData="
            (data) => {
              updateFormData('agent', data)
            }
          "
        />
      </template>

      <template v-if="form.companyType === 2">
        <div class="g-title">个人认证信息</div>
        <PersonalItem
          ref="personalItemRef"
          :joinForm="form"
          @setFormData="
            (data) => {
              updateFormData('legal', data)
            }
          "
        />
      </template>
    </el-form>
  </div>
  <div class="footer">
    <el-button size="large" @click="cancel">取消</el-button>
    <el-button type="primary" size="large" @click="submit">下一步</el-button>
  </div>
</template>

<script setup>
import { nextTick, onMounted, ref } from 'vue'
import AgentItem from './agent-item.vue'
import CompanyItem from './company-item.vue'
import LegalItem from './legal-item.vue'
import PersonalItem from './personal-item.vue'
import { JOIN_TYPE_ENUM } from '@/constants/common'
import userApi from '@/apis/user'
import cityData from '@/common/json/city.json' //省市数据
import { JOIN_STEP_MAP } from './data'

const companyItemRef = ref(null) // 企业信息
const personalItemRef = ref(null) // 个人信息
const legalItemRef = ref(null) // 法定代表人信息
const agentItemRef = ref(null) // 被授权人（经办人）信息
const formRef = ref(null) // 表单ref

const props = defineProps({
  close: {
    type: Function,
    default: () => {},
  },
  nextStep: {
    type: Function,
    default: () => {},
  },
  joinType: {
    type: Number,
    default: null,
  },
  joinData: {
    type: Object,
    default: () => {},
  },
  setJoinData: {
    type: Function,
    default: () => {},
  },
})

const form = ref({
  companyType: 1, //合伙人类型
  cooperationCityCodes: [], //合作城市代码集合
  corpProvinceCode: '', //合作城市省份代码
  corpCityCode: '', //合作城市城市代码
  corpProvinceName: '', //合作城市省份名称
  corpCityName: '', //合作城市城市名称
  equalLegal: 0, // 经办人是否同法人
})

const setData = () => {
  Object.assign(form.value, props.joinData)
}

onMounted(async () => {
  await nextTick()
  setData()
})

const rules = ref({
  companyType: [{ required: true, message: '请选择合伙人类型', trigger: 'change' }],
  cooperationCityCodes: [{ required: true, message: '请选择合作城市', trigger: 'change' }],
})

const cancel = () => {
  props.close()
}

const riskVerification = async () => {
  const {
    companyType,
    corpName,
    companyCreditCode,
    businessLicenseEndDate,
    legalName,
    legalIdentityCard,
    legalIdentityCardEndDate,
    legalPhone,
    agentName,
    agentPhone,
    agentIdentityCard,
  } = form.value
  // 根据合伙人类型构建参数
  const params =
    companyType === 1
      ? {
          companyType,
          companyName: corpName,
          companyCode: companyCreditCode,
          businessLicenseEndDate,
          legalName,
          legalIdentityCard,
          legalIdentityCardEndDate,
          legalPhone,
          agentName,
          agentPhone,
          agentIdentityCard,
        }
      : {
          companyType,
          legalName,
          legalIdentityCard,
          legalIdentityCardEndDate,
          legalPhone,
        }
  try {
    //风控、三要素验证
    await userApi.postRiskVerification(params)
    props.nextStep({
      step: JOIN_STEP_MAP[props.joinType].REBATE_ACCOUNT_INFO.id, //下一步是返佣账号信息
    })
  } catch (error) {
    console.log(error)
  }
}

const submit = async () => {
  //校验表单
  await checkForm()
}

//设置本地缓存数据
const setJoinFormData = () => {
  if (form.value.companyType === 1) {
    Object.assign(form.value, companyItemRef.value.form) //合并企业信息
    Object.assign(form.value, legalItemRef.value.form) //合并法定代表人信息
    Object.assign(form.value, agentItemRef.value.form) //合并被授权人（经办人）信息
  } else {
    Object.assign(form.value, personalItemRef.value.form) //合并个人信息
  }
  props.setJoinData(form.value)
  // JOIN_LOCAL.setJoinFormData(form.value)
}

const checkForm = async () => {
  //校验所有表单
  try {
    // 验证所有表单  区分个人和企业 分别验证
    if (form.value.companyType === 1) {
      await Promise.all([formRef.value.validate(), companyItemRef.value.validate(), legalItemRef.value.validate(), agentItemRef.value.validate()])
      setJoinFormData()
    } else {
      await Promise.all([formRef.value.validate(), personalItemRef.value.validate()])
      setJoinFormData()
    }
    //风控、三要素验证
    await riskVerification()
  } catch (error) {
    console.log(error)
    ElMessage.warning('存在未填写的信息，请检查')
  }
}

// 处理合作城市选择
const cascaderCity = ref(null)
const handleRegionChange = (value) => {
  form.value.corpProvinceCode = value[0]
  form.value.corpCityCode = value[1]
  // 获取省市区的name
  nextTick().then(() => {
    const labelArr = cascaderCity.value.getCheckedNodes()[0].pathLabels // 获取由 label 组成的数组
    form.value.corpProvinceName = labelArr[0]
    form.value.corpCityName = labelArr[1]
  })
}

//更新form数据
const updateFormData = (type, data) => {
  Object.assign(form.value, data)
  if (type === 'legal') {
    //需要更新法人表单数据
    legalItemRef.value && legalItemRef.value.updateForm(data)
  }
  //更新joinData数据
  props.setJoinData(form.value)
}

//经办人是否同法人
const changeEqualLegal = (e) => {
  const obj = {
    agentIdentityCardFrontUrl: e ? legalItemRef.value.form.legalIdentityCardFrontUrl : null, // 经办人身份证人像面
    agentIdentityCardBackUrl: e ? legalItemRef.value.form.legalIdentityCardBackUrl : null, // 经办人身份证国徽面
    agentCardType: e ? legalItemRef.value.form.legalIdentityCardType : 101, // 证件类型
    agentIdentityCard: e ? legalItemRef.value.form.legalIdentityCard : '', //证件号码
    agentIdentityCardFromDate: e ? legalItemRef.value.form.legalIdentityCardFromDate : '', // 开始日期
    agentIdentityCardEndDate: e ? legalItemRef.value.form.legalIdentityCardEndDate : '', // 结束日期
    agentIdentityCardLongTerm: e ? legalItemRef.value.form.legalIdentityCardLongTerm : 0, // 是否长期
    agentName: e ? legalItemRef.value.form.legalName : '', //经办人姓名
    agentPhone: e ? legalItemRef.value.form.legalPhone : '', // 经办人手机号
    agentEmail: e ? legalItemRef.value.form.legalEmail : '', // 经办人电子邮箱
    equalLegal: Number(e), // 是否同法人
  }
  agentItemRef.value && agentItemRef.value.updateEqualLegalData(obj)
}

//合伙人类型切换
// const handelCompanyType = (e) => {}
</script>
